<template>
   <div>
     <figure v-if="!data.videos || !data.videos.video_mp4" :class="data.classNames+'image fixed-opener'">
      <figcaption class="parallax" data-offset="260">
        <img v-if="data.introLogo && data.introLogo.images && data.introLogo.images.length" class="logos" :src="data.introLogo.images[0].url" /><br>
        {{ data.introText }}
      </figcaption>
      <div v-if="data.images" v-for="image in data.images.images" class="inner-fill fixed-bg gallery-item" v-bind:style="{ backgroundImage:'url('+image.url+')' }"></div>
    </figure>

    <VideoBlock v-if="data.videos" :data="Object.assign(data.videos, { classNames: data.classNames+' image full-screen fixed-opener' })">
      <figcaption class="parallax" data-offset="260">
        <img v-if="data.introLogo && data.introLogo.images && data.introLogo.images.length" class="logos" :src="data.introLogo.images[0].url" /><br>
        {{ data.introText }}
      </figcaption>
    </VideoBlock>
   </div>
</template>

<script>
import { firestore } from '../main'
import VideoBlock from '@/components/VideoBlock'

export default {
  name: 'IntroBlock',
  props: ['data'],
  components: {
    VideoBlock
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/IntroBlock.vue